






























































import { Component, namespace, Prop, Vue } from 'nuxt-property-decorator'
import { mdiCheck } from '@mdi/js'
import { IProduct, IProductToCart } from '~/assets/interfaces/products'
import { filterUrl } from '~/assets/filters/url'
import { CART_PATH } from '~/assets/config/path'
import ComponentIcon from '~/components/icon/icon.vue'
import ComponentHeaderWithLink from '~/components/header/header-with-link.vue'
import ComponentPrice from '~/components/price/price.vue'
import ComponentFormButton from '~/components/form/button.vue'
import ComponentProductItem4 from '~/components/products/product-item-4.vue'

const cartStore = namespace('cart')

export interface IProductSetItem extends IProduct {
  active?: boolean
  finalPrice: number
}

@Component({
  components: {
    ComponentHeaderWithLink,
    ComponentPrice,
    ComponentFormButton,
    ComponentProductItem4,
    ComponentIcon,
  },
})
export default class ComponentProductSetMobile extends Vue {
  @cartStore.Action('toCart') public toCart!: (
    product: IProductToCart[]
  ) => Promise<void>

  @Prop({ type: Array, default: [] }) readonly items!: IProductSetItem[]

  private isLoadingToCart = false
  private isInCart = false
  private ids: number[] = []
  private mdiCheck = mdiCheck
  private mainId = -1

  private get sum() {
    let temp = 0
    this.items.forEach((item: IProductSetItem) => {
      if (this.isActive(item.id)) {
        temp = temp + item.finalPrice
      }
    })
    return temp
  }

  public get buttonBuyText() {
    return this.isInCart ? 'В корзине' : 'В корзину'
  }

  private created() {
    this.ids = this.items.map((item) => {
      return item.id
    })
    this.mainId = this.ids[0]
  }

  private async buy() {
    this.isLoadingToCart = true
    if (this.isInCart) {
      await this.$router.push(filterUrl(CART_PATH))
    } else {
      const idsTemp = this.ids.map((item) => {
        return {
          id: item,
          quantity: 1,
        }
      })
      await this.toCart(idsTemp)
    }
    this.isLoadingToCart = false
    this.isInCart = true
  }

  private isActive(id: number) {
    return this.ids.includes(id)
  }

  private toggle(id: number) {
    if (this.mainId !== id) {
      if (this.isActive(id)) {
        this.ids = this.ids.filter((item) => item !== id)
      } else {
        this.ids.push(id)
      }
    }
  }
}
